<template>
        <div class="retangulo_cima">
        <g-card
          class="margem"
          :temCabecalho="false"
          iconeDireita="icone_Resumo.svg"
          largura="auto"
          minAltura="0px"
          altura="100%"
          paddingDefault="15px 20px"
        >

          <div class="titulo-container">
            <div class="titulo">{{titulofechado}}</div>
            <g-button :somenteIcone="true" @click="lateral = true" icone="icone_Resumo.svg" tamanhoIcone="20px" cor="white" largura="50px"></g-button>

          </div>
        </g-card>

         <PSideBar
            class="g-menu-sidebar"
            id="sideBar"
            v-model:visible="lateral"
            position="right"
            :showCloseIcon="false"
            altura="60%"
                >
                    <template #header>
                        <div class="conteudo-cabecalho" >
                          <div class="titulo-e-icone">
                            <img  class="g-menu-logo" src="../../assets/imgs/icone_resumo_barra.svg" />
                            <div class="titulo-resumo"> {{tituloaberto}}</div>
                            </div>
                            <PButton @click="lateral = false" class="p-button-text botao-barras-interno" >
                            <img  class="g-menu-logo" src="../../assets/imgs/icone_fechar_menu.svg" />
                            </PButton>
                        </div>
                    </template>

                    <slot name="conteudo"></slot>

                </PSideBar>

    </div>

</template>

<script>
import gMenuSidebar from './g-menu-sidebar.js'
export default gMenuSidebar
</script>

<style scoped>

/*
.retangulo_cima{
  RESUMO LATERAL DESATIVADO TEMPORARIAMENTE
  NÃO REMOVER DISPLAY NONE
  display: none !important;
}
*/

.margem {
  margin: 0 20px;
}

.titulo {
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 20px;
  font-weight: bold;
  align-self: center;
  padding: 10px;
}
.titulo-container {
  display: flex;
  justify-content: space-between;
}

.conteudo-cabecalho{
 display: flex;
 justify-content: space-between;
 align-items: center;
 justify-items: center;
 padding: 5px;
}

.titulo-resumo{
  font-family: 'MontSerrat';
  color: white;
  font-size: 20px;
  padding: 9px;
}
.titulo-e-icone{
  display: flex;
  justify-content: space-between;
}
</style>
